import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import ButtonIcon from '../common/ButtonIcon';

/**
 * Modal para reimprimir un documento del crédito: arma el PDF al abrirse y lo
 * ofrece para ver/imprimir o descargar. Los modales de fin de trámite
 * (solicitud creada, liquidación completa) llevan su propio mensaje y no usan
 * este.
 */
const DocumentoPdfModal = ({ open, titulo, subtitulo, nota, documento, fileName, onClose }) => (
    <Modal size="md" isOpen={open} toggle={onClose}>
        {/* ModalHeader ya pone el título en un h5: envolverlo en otro anida
            encabezados y React lo reporta como DOM inválido. */}
        <ModalHeader toggle={onClose}>
            {titulo}
            {subtitulo && (
                <span className="text-primary ml-2" style={{ fontSize: '0.8em' }}>{subtitulo}</span>
            )}
        </ModalHeader>
        <ModalBody className="p-3 text-center">
            {nota && <p className="fs--1">{nota}</p>}
            {open && documento && (
                <BlobProvider document={documento}>
                    {({ url, loading, error }) => {
                        if (loading) {
                            return (
                                <span className="fs--1">
                                    <Spinner size="sm" color="primary" className="mr-2" />
                                    Generando documento...
                                </span>
                            );
                        }
                        if (error) {
                            return <span className="fs--1 text-danger">No se pudo generar el documento</span>;
                        }
                        return (
                            <div>
                                {/* Enlace y no window.open: el navegador puede bloquear la
                                    ventana emergente sin avisar y el botón queda muerto. */}
                                <ButtonIcon
                                    color="falcon-default"
                                    size="sm"
                                    icon="print"
                                    className="mr-2 mb-2 mb-sm-0"
                                    tag="a"
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Ver e imprimir
                                </ButtonIcon>
                                <ButtonIcon
                                    color="falcon-default"
                                    size="sm"
                                    icon="arrow-down"
                                    className="mr-2 mb-2 mb-sm-0"
                                    tag="a"
                                    href={url}
                                    download={fileName}
                                >
                                    Descargar
                                </ButtonIcon>
                            </div>
                        );
                    }}
                </BlobProvider>
            )}
        </ModalBody>
        <ModalFooter className="no-border">
            <Button color="primary" size="sm" onClick={onClose}>Cerrar</Button>
        </ModalFooter>
    </Modal>
);

export default DocumentoPdfModal;
